import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { CompanyInsightsService } from 'src/app/_services/company-insights.service';
import * as _ from "underscore";
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { GlobalService } from 'src/app/_services/global.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanyInsightsHistoryMdoalComponent } from 'src/app/company-insights-history-mdoal/company-insights-history-mdoal.component';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
declare const clevertap;

/**
 * Format of data used in recent history
 */
type HISTORY_DATA = {
  type: string,
  name: string,
  companylogo: string | null,
  companyid: string | null,
  updatedon:string | null
}


@Component({
    selector: 'app-company-list',
    templateUrl: './company-list.component.html',
    styleUrls: ['./company-list.component.scss'],
    standalone: false
})
export class CompanyListComponent implements OnInit {

  private typeAheadSubject = new Subject<{event: Event, type:String}>();

  viewMore = false;
  searchKeyword: string;
  companylist: any[]
  typeahead_search: UntypedFormControl = new UntypedFormControl(null)
  companycount: any
  typeaheaddata: any[]
  companyfilter_form = new UntypedFormGroup({
    industry: new UntypedFormControl(null),
    companysize: new UntypedFormControl(null),
    hqlocation: new UntypedFormControl(null)
  })
  typeaheadObj: any
  selectedIndustries:any[] = []
  industryFilterOnRedirect:boolean = false
  selectedLocations: any[] = []
  companysizes: any[] = []
  industry_typeaheads: any = []
  companysize_typeaheads: any = []
  selectedCompanysize:any[] = []
  hqlocations_typeaheads: any = []
  selectedHqLocation: any[] = []
  showIndustryLoader: boolean =false;
  showCompanysizeLoader: boolean =false;
  showLocationLoader: boolean =false;
  showSearchLoader: boolean =false;
  companypagecount: number = 12
  isViewMore: boolean = true;
  companySortBy:  string = 'employeecountdesc';

  /** Recent search data contains unique 5 values from latest 10 searches */
  recentSearchData: HISTORY_DATA[] = [];

  /**Search history */
  historyData: HISTORY_DATA[] = [];

  constructor(private modalService: NgbModal, private CompanyInsightsService: CompanyInsightsService, private route: ActivatedRoute, private router: Router, private personSearchService: PersonSearchService,
    private localStorageService: LocalStorageService) { }

  ngOnInit(): void {
      this.searchKeyword = this.route.snapshot.queryParamMap.get('keyword');
      this.selectedIndustries = this.route.snapshot.queryParamMap.get('industry') ? [this.route.snapshot.queryParamMap.get('industry')] : [];
      this.industryFilterOnRedirect = (this.route.snapshot.queryParamMap.get('industry') || this.route.snapshot.queryParamMap.get('keyword')) && true;
      if (this.searchKeyword) {
        this.typeahead_search.patchValue(this.searchKeyword);
        this.getrecommededcompanylist();
      } else {
        this.getrecommededcompanylist();
      }

      this.typeAheadSubject.pipe(debounceTime(500)).subscribe(({event, type})=>{
        if(type == 'typeahead_search') {
          this.getTypeaheads(event);
          return;
        }
        this.getFilterTypeaheads(event,type);
      })
      this.getHistory();
  }

  getrecommededcompanylist() {
    let payload = {
      startindex: 0,
      resultsize: this.companypagecount,
      searchviaboolean: true,
      booleanquery: this.searchKeyword ? this.searchKeyword: '*',
      industries: this.selectedIndustries,
      locations: this.selectedHqLocation,
      companysizes: this.selectedCompanysize,
      sortby: 'employeecountdesc',
      companybuckettypes: ["Fortun500"]
    }
    if(this.industryFilterOnRedirect) delete payload.companybuckettypes;
    this.CompanyInsightsService.getRecommendedcompanies(payload).subscribe((res:any)=>{
      if(res.status == "success") {
        this.companylist = res.data.results.map(c => ({ ...c, tags: c.tags ? c.tags.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase())) : [] }));
        this.companycount = res.data.totalresultscount

      }
   })
  }

  /**
     * Get recent search history
     */
  async getHistory() {
    const { recentSearchData, historyData} = await this.CompanyInsightsService.getCompanyInsightsRecentSearchAndHistory();
    this.recentSearchData = recentSearchData;
    this.historyData = historyData;
  }

  /**Open company insights histroy modal */
  openSearchHistory(){
    const modalRef = this.modalService.open(CompanyInsightsHistoryMdoalComponent, { windowClass: "small-modal", centered: true });
    modalRef.componentInstance.historyData = this.historyData;
    modalRef.componentInstance.historyClicked.subscribe(res=>{
      if(res){
        this.searchKeyword = res.name;
        this.typeahead_search.patchValue(this.searchKeyword);
        this.getrecommededcompanylist();
      }
    })

  }

  // /**
  //  * Select recent history from dropdown
  //  * @param data
  //  */
  // selectRecentHistory(data) {
  //   if (data.type === 'company') {
  //     this.CompanyInsightsService.setCompanyInsightsHistory({ name: data.name, id: data.companyid }, 'company')
  //     this.router.navigate([`/company-details/${data.companyid}`]);
  //   } else if (data.type === 'industry') {
  //     this.CompanyInsightsService.setCompanyInsightsHistory({ name: data.name }, 'industry')
  //     this.getrecommededcompanylist()
  //     this.getHistory();
  //   }
  // }

  getTypeaheads(event) {
    const input = event.target.value
    this.typeaheaddata = [];
    this.showSearchLoader= true
    if(input) {
      this.CompanyInsightsService.getCompanyTypeaheads(input).subscribe((res:any)=>{
        // this.typeaheaddata = res.data
      const companyList = res.data;
      const companyLogoPayload = res?.data.map(item=>{
        if(item.id || item.value){
          return {
            ...(item?.id && {id: item.id}),
            ...(item?.value && {name: item.value})
          }
        }
      }).filter(Boolean);
      companyLogoPayload?.length &&
      this.personSearchService.getCompanyLogoV2(companyLogoPayload).subscribe((response: any) => {
        this.typeaheaddata = companyList.map(c => ({ ...c, companylogo: response.data.filter(r =>
          {
            if(r.searchedVia === 'id'){
              return r.key === c.id;
            } else if(r.searchedVia === 'name'){
              return r.key === c.value;
            }
          }
        )[0]?.companylogo
      }));
        this.showSearchLoader= false;
      });
      })
    } else {
      this.showSearchLoader= false;
      this.searchKeyword = '';
      this.getrecommededcompanylist();
    }
  }

  // selectTypeahead(data) {
  //   this.typeahead_search.setValue(data.value);
  //   this.searchKeyword = data.value;
  //   if(data.id) {
  //     this.CompanyInsightsService.setCompanyInsightsHistory({name: data.value, id: data.id}, 'company')
  //       this.router.navigate([`/company-details/${data.id}`])
  //   } else{
  //     this.CompanyInsightsService.setCompanyInsightsHistory({name: data.value}, 'industry')
  //     this.getrecommededcompanylist()
  //   }
  // }

  getFilterTypeaheads(type, input) {
    this.industry_typeaheads = [];
    this.companysize_typeaheads = [];
    this.hqlocations_typeaheads = [];
    this.typeaheadObj= {
      startindex: 0,
      resultsize: 10,
      searchviaboolean: true,
      booleanquery: "*",
      industries: this.selectedIndustries,
      locations: this.selectedLocations,
      companysizes: this.selectedCompanysize,
      ...(this.searchKeyword && { companynames: this.companylist.map(c => c.name) })
    }
    if(type == 'industry') {
      this.typeaheadObj['typeahead'] = 'typeahead_industry'
      this.typeaheadObj['input'] = input
      this.showIndustryLoader= true
      this.CompanyInsightsService.getIndustryAggregates(this.typeaheadObj).subscribe((res:any)=>{
        if(res.status == "success") {
          this.industry_typeaheads = res.data.aggs
      this.showIndustryLoader= false

        }
      })
    } else if(type == 'companysize') {
      this.typeaheadObj['typeahead'] = 'typeahead_companysize'
      this.typeaheadObj['input'] = input
      this.showCompanysizeLoader= true
      this.CompanyInsightsService.getIndustryAggregates(this.typeaheadObj).subscribe((res:any)=>{
        if(res.status == "success") {
          this.companysize_typeaheads = res.data.aggs
      this.showCompanysizeLoader= false

        }
      })
    } else if(type == 'location') {
      this.typeaheadObj['typeahead'] = 'typeahead_location'
      this.typeaheadObj['input'] = input
      this.showLocationLoader= true
      this.CompanyInsightsService.getIndustryAggregates(this.typeaheadObj).subscribe((res:any)=>{
        if(res.status == "success") {
          this.hqlocations_typeaheads = res.data.aggs
      this.showLocationLoader= false
        }
      })
    }


  }

  onTypeAheadSearch(event, type){
    this.typeAheadSubject.next({event, type});
  }

  selectOption(value, type) {
    if(type == 'industry') {
      this.selectedIndustries.push(value.key)
      this.companyfilter_form.patchValue({industry: null})
    } else if(type == 'companysize') {
      this.selectedCompanysize.push(value.key)
      this.companyfilter_form.patchValue({companysize: null})
    } else if(type == 'location') {
      this.selectedHqLocation.push(value.key)
      this.companyfilter_form.patchValue({hqlocation: null})
    }
    this.getrecommededcompanylist()
  }

  redirecttoCompanylist(company) {
    this.CompanyInsightsService.setCompanyListData(company);

    this.router.navigate([`/company-details/${company.id}`]);
        /**
           * Company Insights viewed
           */
         const companyInsightsParams = {
          "User ID": this.localStorageService.getItem('userdata').userid,
          "Company name": company.name,
          "Source": "search",
          "Filters Applied": "none"

        }
        clevertap.event.push("Company Insights Viewed",companyInsightsParams);
  }

  unselect(data, type) {
    if(type == 'industry') {
      this.selectedIndustries = _.without(this.selectedIndustries, data)
    } else if(type == 'companysize') {
      this.selectedCompanysize = _.without(this.selectedCompanysize, data)
    } else if(type == 'location') {
      this.selectedHqLocation = _.without(this.selectedHqLocation, data)
    }
    this.getrecommededcompanylist()
  }

  clearAll() {
    this.companyfilter_form.patchValue({
      industry: null,
      companysize: null,
      hqlocation: null
    })
    this.selectedIndustries = []
    this.selectedCompanysize = []
    this.selectedHqLocation = []
    this.getrecommededcompanylist();
  }

  viewAllCompanyListing() {
    if (this.isViewMore) {
      this.companypagecount += 12;
      this.getrecommededcompanylist();
    } else {
      this.isViewMore = true;
      this.companypagecount = this.companypagecount - 12;
      this.getrecommededcompanylist()
    }
  }

  searchCompanies() {
    const inputkeyword = this.typeaheaddata.filter(x=>x.value.toLowerCase() == this.typeahead_search.value.toLowerCase())
    if(inputkeyword.length > 0) {
      this.searchKeyword = this.typeahead_search.value
      this.getrecommededcompanylist();
    }

  }

  removeTypeahead(type: any){
    const maxLength = 3
    switch (type) {
      case 'typeahead_search': {
        if (!(this.typeahead_search && this.typeahead_search.value && this.typeahead_search.value.length >= maxLength)) {
          this.typeaheaddata = []
        }
        break;
      }
    }
  }
  // sortCompanies(value: string) {
  //   this.companySortBy = value;
  //   this.getrecommededcompanylist();
  // }

  ngOnDestroy() {
    this.modalService.dismissAll()
  }
}
